import React from 'react';
import { createPortal } from 'react-dom';

export default function Modal({ isOpen, onConfirm, onCancel, children }) {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-white dark:bg-neutral-800 p-6 w-[90%] max-w-[500px] rounded-none shadow-lg border-2 border-border dark:border-neutral-700 relative">
        {children}
      </div>
    </div>,
    document.body
  );
}
